import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const NavigatingCare: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    width={576}
    height={576}
    fill="none"
    viewBox="0 0 576 576"
    {...props}
  >
    <style>
      {
        '.st0{fill:#d9f6fa}.st1{fill:#80dfea}.st2{fill:#ff612b}.st3{fill:#eb4600}.st4{fill:#b2ebf2}'
      }
    </style>
    <path d="M0 0h576v576H0z" className="st0" />
    <g>
      <ellipse cx={288} cy={459.2} className="st1" rx={87.5} ry={7.6} />
      <path
        d="M284.7 191.2c-22.6 0-41-18.4-41-41s18.4-41 41-41 41 18.4 41 41-18.4 41-41 41zm0-71.9c-17 0-30.9 13.9-30.9 30.9s13.9 30.9 30.9 30.9 30.9-13.9 30.9-30.9-13.9-30.9-30.9-30.9z"
        className="st2"
      />
      <path
        d="M312.3 119.9c6.6 7.3 10.7 17 10.7 27.6 0 22.6-18.4 41-41 41-10.6 0-20.3-4.1-27.6-10.7 7.5 8.2 18.3 13.4 30.3 13.4 22.6 0 41-18.4 41-41 0-12-5.2-22.8-13.4-30.3zM261.5 170.6c-4.8-5.4-7.7-12.6-7.7-20.4 0-17 13.9-30.9 30.9-30.9 7.8 0 15 2.9 20.4 7.7-5.7-6.4-14-10.5-23.2-10.5-17 0-30.9 13.9-30.9 30.9.1 9.3 4.1 17.5 10.5 23.2z"
        className="st3"
      />
      <path
        d="M284.7 163.5c-15.2 0-15.2 4.5-15.2 6.9v47.4s4 10 15.2 10 15.2-10 15.2-10v-47.4c0-2.4 0-6.9-15.2-6.9z"
        className="st2"
      />
      <path
        d="M296.5 165.2c.6.3.9.6.9 1 0 1.2-3.5 2.1-8.3 2.5 2 0 3.5 2.3 3.5 5.5v43.6s-3.1 7.8-11.6 9.6c1.1.2 2.3.4 3.7.4 11.2 0 15.2-10 15.2-10v-47.4c0-1.4 0-3.6-3.4-5.2z"
        className="st3"
      />
      <circle cx={291.3} cy={335.4} r={127.5} className="st3" />
      <circle cx={284.7} cy={328.8} r={127.5} className="st2" />
      <circle cx={284.7} cy={328.8} r={110.8} className="st4" />
      <path
        d="M357 305.3h-48.8v-48.8h-47v48.8h-48.8v46.9h48.8v48.9h47v-48.9H357z"
        className="st0"
      />
      <path
        d="M298.3 329.4c-.1-1.1-.4-2.2-.8-3.2l10.6-49.8v-17.2l-28.2 61.2c-3.8 2.4-6.1 6.7-5.6 11.4.1 1.1.4 2.2.8 3.2l-13.9 64.9v1.3h3.6l27.8-60.3c3.8-2.4 6.2-6.7 5.7-11.5z"
        className="st4"
      />
      <path
        d="M284.7 224.8c-28.7 0-54.7 11.6-73.5 30.4l147 147c18.8-18.8 30.5-44.8 30.5-73.5 0-57.3-46.6-103.9-104-103.9z"
        className="st0"
      />
      <path
        d="M357 305.3h-48.8v-48.8h-47v48.8l47 46.9H357z"
        style={{
          fill: '#fff',
        }}
      />
      <path
        d="M298.3 329.4c-.1-1.1-.4-2.2-.8-3.2l10.6-49.8v-17.2l-28.2 61.2c-.7.5-1.4 1-2 1.6l17 17c2.4-2.4 3.8-5.9 3.4-9.6z"
        className="st0"
      />
      <path
        d="M368.5 322.6V335c0 .5.5.8 1 .6l10.6-6.2c.4-.2.4-.9 0-1.1l-10.6-6.2c-.4-.3-1 0-1 .5z"
        className="st4"
      />
      <path
        d="M200.8 335v-12.4c0-.5-.6-.8-1-.6l-10.6 6.2c-.4.2-.4.9 0 1.1l10.6 6.2c.5.3 1 0 1-.5z"
        className="st1"
      />
      <path
        d="M278.5 244.9h12.4c.5 0 .8-.6.6-1l-6.2-10.6c-.2-.4-.9-.4-1.1 0l-6.2 10.6c-.3.5 0 1 .5 1z"
        className="st4"
      />
      <path
        d="M290.9 412.6h-12.4c-.5 0-.8.5-.6 1l6.2 10.6c.2.4.9.4 1.1 0l6.2-10.6c.3-.4 0-1-.5-1z"
        className="st1"
      />
      <path
        d="m274.2 330-16.7 78.1c-.2.9 1.1 1.4 1.5.5l33.5-72.5-18.3-6.1z"
        style={{
          fill: '#f5b700',
        }}
      />
      <path
        d="m295.2 327.8 16.7-78.1c.2-.9-1.1-1.4-1.5-.5L277 321.7l18.2 6.1z"
        className="st2"
      />
      <circle
        cx={284.7}
        cy={329}
        r={12}
        style={{
          fill: '#000c44',
        }}
      />
      <path
        d="M276.1 320.6c0 .5 0 .9.1 1.4.9 8.9 8.3 15.5 17 15.6 2.5-2.5 4-6 3.6-9.8-.7-6.6-6.6-11.5-13.2-10.8-3 .3-5.6 1.6-7.5 3.6z"
        style={{
          fill: '#002677',
        }}
      />
    </g>
  </Box>
)
export default NavigatingCare
